module.exports = __webpack_public_path__ + "static/img/103042.4b344147.png";